// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Cards__Wrapper_3EYZZ","Inner":"Cards__Inner_1FvMh grid","Title":"Cards__Title_3vLCg","Description":"Cards__Description_1LmdA"};